import { Injectable, OnDestroy } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";

@Injectable({
    providedIn: "root",
})
export default class LocationHistoryService implements OnDestroy {
    private previousUrl: string;
    private currentUrl: string;
    private history: string[] = [];
    routerSub: Subscription;

    constructor(private router: Router) {
        this.currentUrl = this.router.url;
        this.routerSub = router.events.subscribe((event) => {
            if (event instanceof NavigationEnd && this.currentUrl != event.url) {
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.url;
                if (this.history.unshift(event.url) > 10) this.history.pop();
            }
        });
    }

    ngOnDestroy(): void {
        this.routerSub.unsubscribe();
    }

    public getPreviousUrl() {
        return this.previousUrl;
    }

    public getHistory() {
        return this.history;
    }
}
